import JobDemo1Container from "../../components/home/jobDemo1";

const JobDemo1 = () => {
  return <JobDemo1Container />;
};

export default JobDemo1;
